module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"register_modal::cancel-button":"Отменить все изменения","register_modal::save-button":"Сохранить","register_modal::save_text":"Сохранение выполнено успешно"},"en":{"register_modal::cancel-button":"Cancel","register_modal::save-button":"Save","register_modal::save_text":"Saved successfully"}}')
  delete Component.options._Ctor
}
